import { FunctionComponent, useEffect, useState } from 'react';
import getConfig from 'next/config';
import { useRouter } from 'next/router';

import User, { Roles } from 'models/User';

import { mapTranslationsByName } from 'utils/translations';

import SendLinkToPassResetSection from 'components/content/sections/forms/SendLinkToPassReset';
import SetNewPassword from 'components/content/sections/forms/SetNewPassword';
import Button from 'components/layout/Button';
import Header from 'components/layout/Header';
import { HeaderStyles, HeaderTextPositions } from 'components/layout/Header/types';
import LayoutContainer from 'components/layout/LayoutContainer/component';

import StyledComponent from './styles';
import { Props } from './types';

enum States {
    SendLinkToPassReset = 'sendLinkToPassReset',
    SuccessSendEmail = 'successSendEmail',

    SetNewPassword = 'setNewPassword',
    SuccessSetNewPassword = 'successSetNewPassword',
}

const PagePasswordResetSectionSendEmail: FunctionComponent<Props> = ({ translations }) => {
    const [token, setToken]: [string, Function] = useState(null);
    const [userRole, setUserRole]: [Roles, Function] = useState(null);
    const [state, setState]: [States, Function] = useState(States.SendLinkToPassReset);

    const { publicRuntimeConfig } = getConfig();
    const router = useRouter();

    const headerTitle = state?.includes(States?.SuccessSetNewPassword)
        ? translations?.headerSuccess
        : translations?.headerTitle;

    useEffect(() => {
        const token = router?.query?.token;

        if (token) {
            setToken(token);
            setState(States.SetNewPassword);
        }
    }, [router?.query]);


    return (
        <StyledComponent className="page-password-reset-section-send-email">
            <LayoutContainer className="section-wrapper">
                <Header
                    isPrimaryTitle={true}
                    title={headerTitle}
                    description={state?.includes(States.SendLinkToPassReset) && translations?.headerDescription}
                    style={HeaderStyles.Form}
                    textPosition={HeaderTextPositions.Center}
                />
                <div className="sections-wrapper">
                    { state?.includes(States.SendLinkToPassReset) && (
                        <SendLinkToPassResetSection
                            translations={{
                                inputMail: 'Email',
                                submitButton: 'Wyślij link do resetu hasła',
                            }}
                            onSuccess={() => setState(States.SuccessSendEmail)}
                        />
                    )}
                    { state?.includes(States.SuccessSendEmail) && (
                        <>
                            <div
                                className="success-send-email"
                                dangerouslySetInnerHTML={{ __html: translations?.successSendEmail }}
                            />
                            <Button onClick={() => router.push('/')}>
                                {translations?.buttonHomePage}
                            </Button>
                        </>
                    )}
                </div>
                { state?.includes(States.SetNewPassword) && (
                    <SetNewPassword
                        token={token}
                        translations={mapTranslationsByName(['inputPassword',
                            'inputRepeatPassword',
                            'buttonPasswordVisible',
                            'buttonPasswordInvisible',
                            'buttonSubmit',
                        ], translations)}
                        onSuccess={(user: User) => {
                            setState(States.SuccessSetNewPassword);
                            setUserRole(user?.role);
                        }}
                    />
                )}
                { state.includes(States.SuccessSetNewPassword) && (
                    <div className="success-section">
                        <Button
                            onClick={() => userRole === Roles.Physio
                                ? router.push(publicRuntimeConfig.APP_COMPANY_URL)
                                : router.push(publicRuntimeConfig.APP_PATIENT_URL)
                            }
                        >
                            { translations?.buttonRedirect?.replace('{name}', translations?.[userRole]) }
                        </Button>
                    </div>
                )}
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PagePasswordResetSectionSendEmail;